import type { Logger } from '@/interfaces/Logger'

type FieldIssueSummary = Readonly<{ field: string; codes: readonly string[] }>

/** The shape unmappedServerIssues actually reads off a field issue -- not the whole generated type. */
type PointerIssue = Readonly<{ code: string; source: Readonly<{ pointer: string }> }>

const validationFailed = (
  logger: Logger | undefined,
  formId: string,
  fields: readonly FieldIssueSummary[]
): void => {
  logger?.warn('validation_failed', {
    codes: fields.flatMap((entry) => entry.codes),
    fields: fields.map((entry) => entry.field),
    form: formId
  })
}

const unmappedServerIssues = (
  logger: Logger | undefined,
  formId: string,
  issues: readonly PointerIssue[],
  requestId: string | null
): void => {
  if (logger !== undefined) {
    for (const issue of issues) {
      logger.warn('server_issue_unmapped', {
        code: issue.code,
        form: formId,
        pointer: issue.source.pointer,
        request_id: requestId
      })
    }
  }
}

export const formTelemetry = Object.freeze({ unmappedServerIssues, validationFailed })
